import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet } from 'app/shared-components/util/restAPI';

export const fetchPaymentSettings = createAsyncThunk(
  'paymentSettings/fetch',
  async (userId) => {
    const response = await apiGet('CoreAPI3', `/x3/paymentsettings/${userId}`, {});
    return response;
  }
);

const paymentSettingsSlice = createSlice({
  name: 'paymentSettings',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearPaymentSettings: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPaymentSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.data = null;
      });
  },
});

export const { clearPaymentSettings } = paymentSettingsSlice.actions;

export const selectPaymentSettings = (state) => state.paymentSettings.data;
export const selectPaymentSettingsLoading = (state) => state.paymentSettings.loading;

export default paymentSettingsSlice.reducer;
